import type { FieldCheckboxProps } from "./field-checkbox.type";

import { Checkbox, Form } from "antd";

export const FieldCheckbox = ({
  name,
  label,
  text,
  required,
  disabled,
  hidden,
  className,
}: FieldCheckboxProps) => {
  return (
    <Form.Item
      name={name}
      label={label}
      valuePropName="checked"
      rules={required ? [{ required: true }] : undefined}
      required={required}
      hidden={hidden}
      className={className}
    >
      <Checkbox disabled={disabled}>{text}</Checkbox>
    </Form.Item>
  );
};
